import { Card, Input } from '@ui/themed';
import { t } from 'i18next';
import { useEnv } from '../../../../context/env-context';

export function CompanyInfoCard() {
  const { team } = useEnv();

  return (
    <Card>
      <Card.Header headingLevel="h2">
        {t('features:account.pages.settings_account_page.company_info.header')}
      </Card.Header>
      <Card.Body>
        <div className="grid grid-cols-2 gap-4">
          <Input
            label={t(
              'features:account.pages.settings_account_page.company_info.labels.company_name_label',
            )}
            disabled
            value={team.name}
          />
          <Input
            label={t(
              'features:account.pages.settings_account_page.company_info.labels.company_website_label',
            )}
            disabled
            value={team.website}
          />
          <Input
            label={t(
              'features:account.pages.settings_account_page.company_info.labels.site_id_label',
            )}
            disabled
            value={team.slugged_name}
          />
        </div>
      </Card.Body>
    </Card>
  );
}
